module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_waso-39b4b259e15a84d6c1b87cd66f7e285d.jpg";